import LocationCardTabs from 'modules/locations/components/LocationCardTabs';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function OfficesPage() {
  const { t } = useTranslation('locations.OfficesPage');

  return (
    <ProfileSideMenuWrapper title={t('pageTitle')}>
      <LocationCardTabs />
    </ProfileSideMenuWrapper>
  );
}
